import { ParametrsJsonSchemaFieldsType } from '../models/background-task.models';
import {PosibleExecuteType} from '@6grain/masofa-monolith-api-client/common';
import {TASK_ID, TASK_TYPE_DATA} from '@shared/data/task-type-data';

export const POSSIBLE_EXECUTE_TYPES: PosibleExecuteType[] = [
  {
    names: {
      'en-US': 'Daily Backup',
      'ru-RU': 'Ежедневное резервное копирование',
      'uz-Latn-UZ': 'Kunlik zahira nusxa'
    },
    executeTypeName: 'DailyBackup',
    taskType: TASK_ID.Schedule,
    groupName: 'Backup',
    parametrsJsonSchema: [
      {
        fieldName: 'BackupPath',
        fieldLabels: {
          'en-US': 'Backup Path',
          'ru-RU': 'Путь резервного копирования'
        },
        defaultValue: '/backup',
        fieldsType: ParametrsJsonSchemaFieldsType.InputText
      },
      {
        fieldName: 'CompressionLevel',
        fieldLabels: {
          'en-US': 'Compression Level',
          'ru-RU': 'Уровень сжатия'
        },
        defaultValue: 'backup',
        fieldsType: ParametrsJsonSchemaFieldsType.InputNumber
      }
    ]
  }
];

export function getTaskTypeOptions(language: string = 'en-US'): Array<{label: string, value: TASK_ID}> {
  return TASK_TYPE_DATA.map(taskType => ({
    label: taskType.names[language as keyof typeof taskType.names] || taskType.names['en-US'],
    value: taskType.id
  }));
}
